// extracted by mini-css-extract-plugin
module.exports = {"activity__aside":"activity_activity__aside__mCton","user-data__section":"activity_user-data__section__9ayqQ","calendar-list":"activity_calendar-list__2MbiQ"};